import {
  IStocksForYouAPIPayload,
  IStocksForYouAPIResponse,
} from "../types/stocks-for-you-types.types";
import { API_PATHS } from "../constants/api-paths";
import { request } from "../core/api.client";

export const getStocksForYou = async (payload: IStocksForYouAPIPayload) => {
  const response: IStocksForYouAPIResponse = await request({
    method: "POST",
    url: `${API_PATHS.stocksForYou}`,
    data: payload,
  });
  return response;
};
